import { render, staticRenderFns } from "./workRecordsPersonalPage.vue?vue&type=template&id=381928a0&"
import script from "./workRecordsPersonalPage.vue?vue&type=script&lang=ts&"
export * from "./workRecordsPersonalPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports